import { useState } from 'react'
import Card from '../../shared/card/Card'
import { ScrollView, View, Text, ActivityIndicator } from 'react-native'
import { globalStyles } from '../../../static/styles/global'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import CustomButton from '../../shared/button/Button'
import { usePersonalStore } from '../../../stores/personalInfo'
import { useFormsStore } from '../../../stores/onboarding'
import { useInitializeStore } from '../../../stores/initialize'
import Toast from 'react-native-toast-message'
import moment from 'moment'
import Canvas from '../../canvas'
import { NativeStackScreenProps } from '@react-navigation/native-stack';
import SignatureFormView from '../SignatureFormView'

type Props = NativeStackScreenProps<any, any>;

const KyInformationonline = ({ navigation, route }: Props) => {
  const {
    values,
    userId,
    mode,
    essUserOnBoardingKey,
    essUserOnBoardingFormKey,
  } = route.params

  const personalstore = usePersonalStore()
  const intializestore = useInitializeStore()

  const { postkyonline, loading } = useFormsStore()

  const handlesubmit = async (signatureDataURL: any) => {
    const data = {
      essUserOnBoardingFormKey: essUserOnBoardingFormKey,
      essObKey: essUserOnBoardingKey,
      completeOnline: true,
      essUserKey: intializestore.initializeData.userkey,
      entityId: personalstore.personalData?.entityId,
      incomeTaxLiabilityExpected: Number(values.incomeTaxLiabilityExpected) == 0 ? false : true,
      qualifyExcemptionCertificate: Number(values.qualifyExcemptionCertificate) == 0 ? false : true,
      stateOfResident: values?.stateOfResident ? values.stateOfResident : null,
      nonresidentMilSpouseExcemption: Number(values.qualifyNonresidentMilitarySpouseExcemption) == 0 ? false : true,
      workInKentucky: Number(values.workInKentucky) == 0 ? false : true,
      additionalWithholding: values.additionalWithholding ? values.additionalWithholding : null,
      sign: signatureDataURL,
      maritalStatus: values?.martialstatus,
    }
    const response = await postkyonline(data)
    if (response?.success) {
      await Toast.show({
        type: 'success',
        position: 'bottom',
        text1: response?.message,
        visibilityTime: 3000,
        autoHide: true,
        topOffset: 60,
        onHide: () => {
          navigation.replace('OnboardingForms')
        }
      })
    }
    else {
      await Toast.show({
        type: 'error',
        position: 'bottom',
        text1: response?.message,
        visibilityTime: 3000,
        autoHide: true,
        topOffset: 60
      })
    }
  }

  return (
    <>
      <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
        <View style={[globalStyles.horizontalPadGap]}>
          <HomeDetailsHeader
            navLabel="Forms"
            navScreen="OnboardingForms"
            title={'KY Withholding Taxation'}
          />
        </View>
      </View>
      <SignatureFormView
        essUserOnBoardingFormKey={essUserOnBoardingFormKey}
        essUserOnBoardingKey={essUserOnBoardingKey}
        isSubmitting={loading}
        onPrevious={() =>
          navigation.navigate('KyInformationForm', {
            essUserOnBoardingFormKey,
            essUserOnBoardingKey,
            values,
            mode: "online",
          })
        }
        onSubmit={handlesubmit}
      />
    </>
  )
}
export default KyInformationonline
